import { alpha, useTheme } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

import { useSession } from '@hooks';
import { ShareMenu, WriteButton } from '../../common';
import useStyles from './styles';
import { HeaderProps } from './types';
import StatCards from './StatCards';
import { FriendRequestButton } from '../buttons/FriendRequestButton';

function DesktopHeader(props: Readonly<HeaderProps>) {
  const { consumer, handleTabChange, activeTab, handleBack } = props;
  const theme = useTheme();
  const { account } = useSession();
  const styles = useStyles(theme);
  const { t } = useTranslation('cta');

  if (!consumer) {
    return null;
  }

  return (
    <>
      <Stack
        direction="row"
        justifyContent={'space-between'}
        p={1}
        sx={{
          position: 'absolute',
          zIndex: 1,
          width: '100%',
          backdropFilter: 'blur(15px)',
          backgroundColor: alpha(theme.palette.background.paper, 0.5),
        }}
      >
        <Stack direction="row" alignItems="center" onClick={handleBack} sx={{ cursor: 'pointer' }}>
          <theme.icons.back />
          <Typography> {t('back')}</Typography>
        </Stack>
        <Stack direction="row" spacing={2} alignItems={'center'} pr={1}>
          <ShareMenu type="consumer" idOrSlug={consumer.slug} />
        </Stack>
      </Stack>

      <Stack spacing={3} pt={10} alignItems="center">
        <Avatar src={consumer.avatar?.url} sx={{ width: 200, height: 200 }} />
        <Stack spacing={1} px={3} alignItems="center">
          <Typography variant="h4" color="textPrimary" textAlign="center">
            {consumer.name}
          </Typography>
          <Typography variant="body2" color="textSecondary" textAlign="center">
            @{consumer.slug}
          </Typography>
        </Stack>
        <StatCards consumer={consumer} />
        {consumer.id !== account?.id && (
          <Stack spacing={1} px={2} width="100%" direction="row">
            <FriendRequestButton consumerId={consumer.id} />
            <WriteButton recipientId={consumer.id} />
          </Stack>
        )}
      </Stack>

      {/* TABS */}
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        textColor="inherit"
        indicatorColor="primary"
        aria-label="tabs-spot-menu"
        variant="fullWidth"
        sx={{
          mt: 3,
          zIndex: 1,
          width: '100%',
          backdropFilter: 'blur(15px)',
          backgroundColor: alpha(theme.palette.background.paper, 0.5),
          bottom: 0,
        }}
      >
        {/* <Tab icon={<theme.icons.home sx={isMobile ? { fontSize: '0.9rem'} : {} } />} sx={styles.tab} /> */}
        <Tab icon={<theme.icons.home />} sx={styles.tab} />
        <Tab icon={<theme.icons.image />} sx={styles.tab} />
        <Tab
          icon={
            <Badge
              color="error"
              badgeContent={consumer.friendships.pending?.list.filter(({ isSent }) => !isSent).length ?? 0}
              max={100}
            >
              <theme.icons.friends />
            </Badge>
          }
          sx={styles.tab}
        />
        {/* <Tab icon={<theme.icons.feedback />} sx={styles.tab} /> */}
      </Tabs>
    </>
  );
}

export default DesktopHeader;
